import { render, staticRenderFns } from "./subject-form-2.vue?vue&type=template&id=24e320ea&scoped=true&"
import script from "./subject-form-2.vue?vue&type=script&lang=ts&"
export * from "./subject-form-2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e320ea",
  null
  
)

export default component.exports